module.exports = "/_next/static/images/bank-bni-icon-1ccc42f14b6cdfad6f56c6d1c5c1d952.svg";